import FullScreenLoader from '@/components/FullScreenLoader';
import { useQuoteTemplateFormFields } from '@/queries/templates';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';
import CostEstimations from './CostEstimations';
import PricingModel from './PricingModel';

export default function PricingDetails() {
    const [formData, activeQuote] = useQuoteIntakeSetupStore((state) => [
        state.formData,
        state.activeQuote,
    ]);

    const { data: templateFormFields = [], isPending } = useQuoteTemplateFormFields(
        activeQuote.quoteTemplateId,
        true,
    );

    if (isPending) {
        return <FullScreenLoader />;
    }

    return (
        <>
            {formData.step3.isScreenTwo === false && templateFormFields.length > 0 && (
                <PricingModel templateFormFields={templateFormFields} />
            )}
            {formData.step3.isScreenTwo === true && templateFormFields.length > 0 && (
                <CostEstimations templateFormFields={templateFormFields} />
            )}
        </>
    );
}
